import React, { useMemo } from 'react'
import { get, pick } from 'lodash-es'
import { useTbViewStore, useProjectStore } from '@vt/hooks'
import { Button } from '@ow/comps'
import styled from '@emotion/styled'
import defaultImg from '../../assets/default-img.png'

const MediaItemStyled = styled.div`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  .operate {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    div,
    button {
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .shadow {
    background: rgba(0, 0, 0, 0);
    padding: 5px;
  }
  .item-desc {
    opacity: 0;
  }
  &:hover {
    .shadow {
      background: rgba(0, 0, 0, 0.2);
    }
    .item-desc {
      opacity: 1;
    }
  }
`

const DefaultOperateComponent = ({
  onClickOpenDetail,
  rowData,
  operatorConfig = {},
}) => {
  const operators = (operatorConfig && operatorConfig.elements) || []
  const detailOpt = operators.find((v) => v.actionType === 'detailConfig')
  if (!detailOpt) {
    return null
  }

  return (
    <div>
      <Button
        type="primary"
        opacityType="transparent"
        style={{
          fontSize: '14px',
          margin: '0 -4px',
        }}
        onClick={() => {
          onClickOpenDetail(rowData)
        }}
      >
        查看详情
      </Button>
    </div>
  )
}
const TableContainer = function ({ showTbDetail, editTbData }) {
  const { total } = useTbViewStore((state) => pick(state, ['total']))
  const { tbData, fields, mediaConfig, destroyTbData, operatorConfig } =
    useTbViewStore((state) =>
      pick(state, [
        'destroyTbData',
        'tbData',
        'fields',
        'mediaConfig',
        'operatorConfig',
      ])
    )

  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )

  const { OperateComponent } = customCompsMap || {}

  const renderSlug = useMemo(() => {
    if (mediaConfig && mediaConfig.fields) {
      return mediaConfig.fields
    }
    return fields.filter((v) => {
      return !v.hidden
    })
  }, [fields])

  const operateProps = {
    onClickDestroyData: destroyTbData,
    onClickOpenDetail: showTbDetail,
    onClickUpdateData: editTbData,
  }

  return (
    <div className="flex flex-col w-full overflow-y-hidden">
      <div
        className="h-8"
        style={{
          fontWeight: 500,
          fontSize: '18px',
          color: '#000000',
          lineHeight: '30px',
          height: '30px',
          marginBottom: '10px',
        }}
      >
        相关结果约{total}条
      </div>
      <div className="flex-1 w-full h-full overflow-auto">
        <div className="flex flex-wrap">
          {tbData.map((item) => {
            operateProps.rowData = item
            operateProps.operatorConfig =
              operatorConfig && operatorConfig.operatorConfig
            return (
              <div
                style={{
                  borderRadius: '0',
                  padding: '5px',
                  minHeight: '200px',
                }}
                className="flex bg-white flex-wrap md:w-1/4 sm:w-1/2 lg:w-1/5"
              >
                <MediaItemStyled
                  className="bg-gray-100 w-full rounded transition-all relative"
                  style={{
                    backgroundImage:
                      mediaConfig && mediaConfig.imageSlug
                        ? `url(${get(
                            item,
                            `${mediaConfig.imageSlug}[0].src`,
                            `${defaultImg}`
                          )})`
                        : `url(${defaultImg})`,
                  }}
                >
                  {(!mediaConfig ||
                    !mediaConfig.imageSlug ||
                    get(item, `${mediaConfig.imageSlug}[0].src`, '') ===
                      '') && (
                    <div
                      style={{
                        position: 'absolute',
                        left: '0',
                        right: '0',
                        bottom: '22px',
                        textAlign: 'center',
                        fontSize: '14px',
                        color: 'rgba(0,0,0,0.8)',
                      }}
                    >
                      未上传图片
                    </div>
                  )}

                  <div className="shadow flex flex-col justify-end h-full">
                    <div
                      className="w-full flex mb-1 justify-end operate"
                      style={{ color: 'rgba(0,0,0,0.40)', fontSize: '12px' }}
                    >
                      {OperateComponent ? (
                        <OperateComponent {...operateProps}>
                          <DefaultOperateComponent {...operateProps} />
                        </OperateComponent>
                      ) : (
                        <DefaultOperateComponent {...operateProps} />
                      )}
                    </div>
                    <div className="flex flex-col text-white item-desc gap-1.5">
                      {renderSlug.map((slug, index) => {
                        return (
                          <p
                            key={`img-item-desc-${index}`}
                            className={
                              index === 0
                                ? 'text-base truncate font-bold'
                                : 'text-sm truncate'
                            }
                          >
                            {slug.title && `${slug.title}: `}
                            {item[slug.slug]}
                          </p>
                        )
                      })}
                    </div>
                  </div>
                </MediaItemStyled>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TableContainer
